// Shared by the SEO indexing gate (isHeadlinePromoOpenForLocale) and the
// runtime access gate (checkHeadlinePromoCountryMatch) - both apply the same
// allow/deny logic once a country is known; they only differ on how an
// unresolvable country falls back.
export const isCountryAllowed = (
  country: string,
  allowedCountries?: string[],
  disallowedCountries?: string[]
): boolean => {
  if (disallowedCountries?.includes(country)) return false;
  if (!allowedCountries?.length) return true;
  return allowedCountries.includes(country);
};
